import _extends from "@babel/runtime-corejs2/helpers/extends";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import Popup from './Popup';
import classNames from 'classnames';
import { ContextConsumer } from './Context';
import NavItem from './NavItem';
import NavTooltip from './NavTooltip';

var NavDropdown = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NavDropdown, _React$PureComponent);

  var _super = _createSuper(NavDropdown);

  function NavDropdown() {
    var _this;

    _classCallCheck(this, NavDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onOpen", function () {
      var _this$props = _this.props,
          onOpen = _this$props.onOpen,
          setHasOpenMenu = _this$props.setHasOpenMenu;

      if (typeof onOpen === 'function') {
        onOpen();
      }

      setHasOpenMenu(true);
    });

    _defineProperty(_assertThisInitialized(_this), "onClose", function () {
      var _this$props2 = _this.props,
          onClose = _this$props2.onClose,
          setHasOpenMenu = _this$props2.setHasOpenMenu;

      if (typeof onClose === 'function') {
        onClose();
      }

      setHasOpenMenu(false);
    });

    return _this;
  }

  _createClass(NavDropdown, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          hover = _this$props3.hover,
          inverted = _this$props3.inverted,
          isActive = _this$props3.isActive,
          isOpen = _this$props3.isOpen,
          label = _this$props3.label,
          pinned = _this$props3.pinned,
          position = _this$props3.position,
          tooltip = _this$props3.tooltip,
          banner = _this$props3.banner,
          onMouseOver = _this$props3.onMouseOver,
          onMouseOut = _this$props3.onMouseOut,
          onFocus = _this$props3.onFocus,
          onBlur = _this$props3.onBlur;
      var content = /*#__PURE__*/React.createElement("div", {
        className: "nav-dropdown-trigger",
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onFocus: onFocus,
        onBlur: onBlur
      }, label);
      var wrapperClassName = classNames("cloud-ui-nav-menu ".concat(className), {
        'with-banner': banner
      });
      return /*#__PURE__*/React.createElement(Popup, {
        trigger: /*#__PURE__*/React.createElement(NavItem, {
          isActive: isActive,
          isOpen: isOpen,
          className: className,
          "data-qa": 'nav-dropdown-trigger'
        }, tooltip ? /*#__PURE__*/React.createElement(NavTooltip, {
          className: className,
          trigger: content,
          position: position,
          open: !isOpen && hover,
          inverted: inverted
        }, tooltip) : content),
        className: wrapperClassName,
        popper: {
          className: "cloud-ui-nav-menu-popper ".concat(wrapperClassName)
        },
        on: "click",
        pinned: pinned,
        position: position,
        open: isOpen,
        onClose: this.onClose,
        onOpen: this.onOpen,
        inverted: inverted,
        "data-qa": "nav-dropdown-menu"
      }, children);
    }
  }]);

  return NavDropdown;
}(React.PureComponent);

export var withNavDropdownEvents = function withNavDropdownEvents(WrappedComponent) {
  var _temp;

  return _temp = /*#__PURE__*/function (_React$PureComponent2) {
    _inherits(_temp, _React$PureComponent2);

    var _super2 = _createSuper(_temp);

    function _temp() {
      var _this2;

      _classCallCheck(this, _temp);

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _super2.call.apply(_super2, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this2), "state", {
        isOpen: false,
        hover: false
      });

      _defineProperty(_assertThisInitialized(_this2), "onClose", function () {
        _this2.setState({
          isOpen: false,
          hover: false
        });
      });

      _defineProperty(_assertThisInitialized(_this2), "onOpen", function () {
        _this2.setState({
          isOpen: true,
          hover: false
        });
      });

      _defineProperty(_assertThisInitialized(_this2), "onMouseOver", function () {
        _this2.setState({
          hover: true
        });
      });

      _defineProperty(_assertThisInitialized(_this2), "onMouseOut", function () {
        _this2.setState({
          hover: false
        });
      });

      return _this2;
    }

    _createClass(_temp, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, this.state, {
          onClose: this.onClose,
          onOpen: this.onOpen,
          onMouseOver: this.onMouseOver,
          onMouseOut: this.onMouseOut,
          onFocus: this.onMouseOver,
          onBlur: this.onMouseOut
        }));
      }
    }]);

    return _temp;
  }(React.PureComponent), _temp;
};

var NavDropdownWrapper = function NavDropdownWrapper(props) {
  return /*#__PURE__*/React.createElement(ContextConsumer, null, function (_ref) {
    var setHasOpenMenu = _ref.setHasOpenMenu,
        banner = _ref.banner;
    return /*#__PURE__*/React.createElement(NavDropdown, _extends({}, props, {
      setHasOpenMenu: setHasOpenMenu,
      banner: banner
    }));
  });
};

export { NavDropdownWrapper as NavDropdown };
export default withNavDropdownEvents(NavDropdownWrapper);